/* eslint-disable */

class FeaturedContentTextImage {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$module2 = this.sectionsContainer.querySelectorAll('.featured-content-text-image');
		
		if (!this.$module2.length) {
			return;
		}
			
		this.$module2Elements = [];
		this.$module2Button = [];

		this.$module2.forEach(module => {
			this.$module2Elements.push(module.querySelectorAll('.anima'));
			this.$module2Button.push(module.querySelector('.buttonAnima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$module2.forEach((module, index) => {
			gsap.set(module, { opacity: 1 });
			
			if (this.$module2Elements[index].length) {
				gsap.set(this.$module2Elements[index], { yPercent: 20, opacity: 0.0001 });
			}

			if (this.$module2Button[index]) {
				gsap.set(this.$module2Button[index], { scale: 0.9, opacity: 0.0001, transformOrigin: 'center center' });
			}

			this.initAnimate(index);
		});
	}

	initAnimate(index) {
		this.animateModule2 = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$module2[index],
                start: 'top 70%',
			},
			onComplete: () => {
				if (this.$module2Elements[index].length) {
					gsap.set(this.$module2Elements[index], { clearProps: true });
				}
				if (this.$module2Button[index]) {
					gsap.set(this.$module2Button[index], { clearProps: true });
				}
			}
        });
    
        this.animateModule2.addLabel('step1');
        this.animateModule2.to(this.$module2[index], { opacity: 1, duration: 1 }, 'step1');
		
		if (this.$module2Elements[index].length) {
			this.animateModule2.to(this.$module2Elements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
		}
		
		if (this.$module2Button[index]) {
			this.animateModule2.to(this.$module2Button[index], { scale: 1, opacity: 1 }, 'step1+=0.7');
		}
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default FeaturedContentTextImage;
